import {inject, injectable} from 'inversify';

import type {Expand, MaybeExpanded} from '../../../../api/types';
import type {OfferMapperJrpc} from '../../Offer/mappers/Offer.mapper.jrpc';
import type {SubtenantMapperJrpc} from '../../Subtenant/mappers/Subtenant.mapper.jrpc';
import type {UserMapperJrpc} from '../../User/mappers/User.mapper.jrpc';

import {extendExpand} from '../../../../api/utils/expand';
import {BaseExpandJrpc} from '../../../domain/Base/mappers/Base.expand.jrpc';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {OfferExpandJrpc} from '../../Offer/mappers/Offer.expand.jrpc';
import {SubtenantExpandJrpc} from '../../Subtenant/mappers/Subtenant.expand.jrpc';
import {UserExpandJrpc} from '../../User/mappers/User.expand.jrpc';

@injectable()
export class CouponExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(UserExpandJrpc) private userExpand: UserExpandJrpc,
    @inject(OfferExpandJrpc) private offerExpand: OfferExpandJrpc,
    @inject(SubtenantExpandJrpc) private subtenantExpand: SubtenantExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      coupon: [
        ['employer_id', null, this.userExpand.getByEnv(key)],
        ['resource_id', null, this.offerExpand.getByEnv(key)],
        [
          'option_resource_ids->option_resources',
          null,
          this.offerExpand.getByEnv(key),
        ],
      ],
    };
    const core: Expand = extendExpand(base, [
      ['subtenant_id', null, this.subtenantExpand.getByEnv(key)],
    ]);
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace CouponExpandJrpc {
  export type ExpandedFields = {
    employer: MaybeExpanded<UserMapperJrpc.ExpandedApiData>;
    option_resources: MaybeExpanded<OfferMapperJrpc.ExpandedApiData>[];
    resource: MaybeExpanded<OfferMapperJrpc.ExpandedApiData>;
    subtenant: MaybeExpanded<SubtenantMapperJrpc.ExpandedApiData>;
  };
}
